import { EducationalHub } from "./EducationalHub";
import { MainSpecializations } from "./TypeSpecialist";
import { TypeUserData } from "./TypeUsers";

export enum PublicationKind {
  BOOK = "BOOK",
  GUIDE = "GUIDE",
  AUDIOBOOK = "AUDIOBOOK",
  OTHER = "OTHER",
}

export enum PublicationFileFormat {
  PDF = "PDF",
  AUDIO = "AUDIO",
}

export enum PublicationFilterScope {
  CATALOG = "CATALOG",
  OWNED = "OWNED",
  MANAGEABLE = "MANAGEABLE",
  ALL = "ALL",
}

export enum PublicationSort {
  NEWEST = "NEWEST",
  APPROVE_REQUESTED_AT_DESC = "APPROVE_REQUESTED_AT_DESC",
  TITLE_ASC = "TITLE_ASC",
  TITLE_DESC = "TITLE_DESC",
  PRICE_ASC = "PRICE_ASC",
  PRICE_DESC = "PRICE_DESC",
  RATING_DESC = "RATING_DESC",
}

export type PublicationFile = {
  _id?: string;
  title: string;
  description: string;
  order: number;
  format: PublicationFileFormat;
  isPreviewAvailable: boolean;
  fileMetadata?: {
    _id: string;
    originalName?: string;
    mimeType?: string;
    size?: number;
  };
};

export type AccessiblePublicationFile = Omit<
  PublicationFile,
  "fileMetadata"
> & {
  url: string;
  expiresIn: number;
};

export type Publication = {
  _id: string;
  shortId: string;
  createdBy: TypeUserData | string;
  educationalHub?: EducationalHub | string;
  title: string;
  description?: string;
  logo?: string;
  logoUrl?: string;
  language: string;
  kind?: PublicationKind;
  mainSpecialization?: MainSpecializations | string;
  cost: number;
  files?: PublicationFile[];
  isActive: boolean;
  isApproved: boolean;
  isApproveRequested: boolean;
  approveRequestedAt?: string;
  approvedAt?: string;
  reviewedAt?: string;
  reviewDeclined: boolean;
  reviewDeclineReason?: string;
  deleted: boolean;
  createdAt: string;
  updatedAt: string;
};

export type PublicationFilters = {
  scope: PublicationFilterScope;
  page: number;
  limit: number;
  text?: string;
  isActive?: boolean;
  isApproved?: boolean;
  isApproveRequested?: boolean;
  reviewDeclined?: boolean;
  deleted?: boolean;
  sort?: PublicationSort;
};

export type FilteredPublicationsResponse = {
  status: boolean;
  message?: string;
  publications?: Publication[];
  totalAmount?: number;
};

export type PublicationFilesResponse = {
  status: boolean;
  message?: string;
  files?: AccessiblePublicationFile[];
};

export type PublicationFileAccessResponse = {
  status: boolean;
  message?: string;
  file?: AccessiblePublicationFile;
};

export type PublicationModerationUpdate =
  | { isApproved: true }
  | { reviewDeclined: true; reviewDeclineReason: string };

export type PublicationUpdateResponse = {
  status: boolean;
  message?: string;
  publication?: Publication;
  incorrectFields?: string[];
};

export type PublicationAcquisitionStatistics = {
  total: number;
  active: number;
  revoked: number;
};
